/* Below the Surface v5 product page: gallery, buy box (plans mirror the store's
   quantity/frequency discount rules), gift meter, complete-the-ritual, sticky bar
   and the supplement-facts drawer. Uses AK5.addToCart from ak5.js. */
(function () {
  'use strict';
  // Oct 22 2026: format in the shopper's currency (Shopify Markets), e.g. £21.21 or ¥4,457, not a hard-coded $
  var money = function (c) { var f = window.AK5fmt && window.AK5fmt(c); if (f) return f; var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'; try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).format(c / 100); } catch (e) { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(c / 100); } catch (e2) { return '$' + (c / 100).toFixed(2); } } };

  /* ---------- gallery ---------- */
  document.querySelectorAll('[data-ak5-gallery]').forEach(function (gal) {
    var track = gal.querySelector('[data-ak5-slides]');
    if (!track) return;
    var slides = track.children, n = slides.length;
    var thumbs = gal.querySelectorAll('[data-ak5-thumb]');
    var dots = gal.querySelectorAll('[data-ak5-dot]');
    var cur = 0;
    function sync(i) {
      cur = i;
      thumbs.forEach(function (t) { t.classList.toggle('is-on', Number(t.getAttribute('data-ak5-thumb')) === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      for (var k = 0; k < n; k++) { var v = slides[k].querySelector('video'); if (v && k !== i && !v.paused) { v.pause(); slides[k].classList.remove('is-playing'); } }
    }
    function go(i) { i = (i + n) % n; track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); sync(i); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.getAttribute('data-ak5-thumb'))); }); });
    gal.querySelectorAll('[data-ak5-gprev]').forEach(function (b) { b.addEventListener('click', function () { go(cur - 1); }); });
    gal.querySelectorAll('[data-ak5-gnext]').forEach(function (b) { b.addEventListener('click', function () { go(cur + 1); }); });
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur && i >= 0 && i < n) sync(i); });
    }, { passive: true });
    track.querySelectorAll('.ak5-slide--video').forEach(function (s) {
      var v = s.querySelector('video'); if (!v) return;
      s.addEventListener('click', function () { if (v.paused) { v.muted = false; v.play(); s.classList.add('is-playing'); } else { v.pause(); s.classList.remove('is-playing'); } });
      v.addEventListener('ended', function () { s.classList.remove('is-playing'); });
    });
    sync(0);
  });

  /* ---------- purity drawer shortcut ---------- */
  document.querySelectorAll('[data-ak5-lab]').forEach(function (b) {
    b.addEventListener('click', function () { var t = document.querySelector('[data-akl-open]'); if (t) t.click(); else { var l = document.querySelector('#lab'); if (l) l.scrollIntoView({ behavior: 'smooth' }); } });
  });

  /* ---------- info row: Details / FAQs drop down on tap (closed by default) ---------- */
  document.querySelectorAll('[data-ak5-dd]').forEach(function (dd) {
    var ts = dd.querySelectorAll('[data-ak5-dd-t]');
    ts.forEach(function (t) {
      t.addEventListener('click', function () {
        var key = t.getAttribute('data-ak5-dd-t'), open = t.getAttribute('aria-expanded') !== 'true';
        ts.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); o.classList.remove('is-on'); });
        dd.querySelectorAll('[data-ak5-dd-p]').forEach(function (p) { p.hidden = true; });
        if (open) { t.setAttribute('aria-expanded', 'true'); t.classList.add('is-on'); var p = dd.querySelector('[data-ak5-dd-p="' + key + '"]'); if (p) p.hidden = false; }
      });
    });
  });
  /* facts bottom sheet: lock page scroll while open */
  document.querySelectorAll('[data-ak5-open-facts]').forEach(function (b) {
    b.addEventListener('click', function () { if (document.querySelector('dialog.ak5-sheet')) document.documentElement.classList.add('ak5-lock'); });
  });
  document.querySelectorAll('dialog.ak5-sheet').forEach(function (d) {
    d.addEventListener('close', function () { document.documentElement.classList.remove('ak5-lock'); });
  });
  /* ---------- CTA bubbles: a little burst from the arrow on tap ---------- */
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('.ak5-cta[data-ak5-cta],[data-ak5-satc-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (calm) return;
      var r = btn.getBoundingClientRect(), x0 = btn.classList.contains('ak5-cta') ? r.width - 32 : r.width / 2;
      for (var i = 0; i < 8; i++) {
        var s = document.createElement('i');
        s.className = 'ak5-cta__bub';
        s.style.left = (x0 + (Math.random() * 30 - 15)) + 'px';
        s.style.setProperty('--s', (6 + Math.random() * 10) + 'px');
        s.style.setProperty('--dx', (Math.random() * 40 - 20) + 'px');
        s.style.animationDelay = (i * 45) + 'ms';
        btn.appendChild(s);
        setTimeout(function (el) { return function () { el.remove(); }; }(s), 1400);
      }
    });
  });

  /* ---------- facts drawer ---------- */
  document.querySelectorAll('[data-ak5-open-facts]').forEach(function (b) {
    b.addEventListener('click', function () { var d = document.querySelector('[data-ak5-facts]'); if (!d) return; if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', ''); });
  });
  document.querySelectorAll('[data-ak5-facts]').forEach(function (d) {
    d.querySelectorAll('[data-ak5-close]').forEach(function (b) { b.addEventListener('click', function () { d.close ? d.close() : d.removeAttribute('open'); }); });
    d.addEventListener('click', function (e) { if (e.target === d) { d.close ? d.close() : d.removeAttribute('open'); } });
  });

  /* ---------- buy box ---------- */
  var box = document.querySelector('[data-ak5-buybox]');
  if (!box) return;
  var cfg = JSON.parse(box.querySelector('[data-ak5-cfg]').textContent);
  var state = { mode: cfg.defaultMode || 'sub', sub: 0, once: 0 };
  var segBtns = box.querySelectorAll('[data-ak5-mode]');
  var subWrap = box.querySelector('[data-ak5-sub]');
  var onceWrap = box.querySelector('[data-ak5-once]');
  var cta = box.querySelector('[data-ak5-cta]');
  var added = box.querySelector('[data-ak5-added]');
  var gift = box.querySelector('[data-ak5-gift]');
  var satc = document.querySelector('[data-ak5-satc]');
  var satcLine = satc && satc.querySelector('[data-ak5-satc-line]');
  var satcBtn = satc && satc.querySelector('[data-ak5-satc-add]');

  function priceFor(o) {
    var unit = cfg.base - Math.floor(cfg.base * (100 - o.pct) / 100);
    return { now: unit * o.qty, was: cfg.base * o.qty, unit: unit, off: 100 - o.pct };
  }
  function unitWord(q) { return q === 1 ? cfg.unitOne : cfg.unitMany; }
  function current() { return state.mode === 'sub' ? cfg.subscribe[state.sub] : cfg.once[state.once]; }

  var optCards = box.querySelectorAll('[data-ak5-opt]');
  var sumLine = box.querySelector('[data-ak5-sum]');
  function freq(m) { return m === 1 ? 'Every month' : 'Every ' + m + ' months'; }
  function freqS(m) { return m === 1 ? 'Monthly' : 'Every ' + m + ' mo'; }
  function tile(o, i, on, kind) {
    var p = priceFor(o);
    var flag = kind === 'sub' && o.qty === 3 ? '<span class="ak5-qty__flag">Best value</span>' : '';
    var sub = kind === 'sub' ? freq(o.months) : (o.qty === 1 ? 'Single' : o.qty + '-pack');
    var subS = kind === 'sub' ? freqS(o.months) : sub;
    var gift = cfg.gift && o.qty >= cfg.gift.min ? '<span class="ak5-qty__gift">+ Free mist</span>' : '';
    return '<button type="button" class="ak5-qty' + (on ? ' is-on' : '') + '" data-ak5-' + (kind === 'sub' ? 'plan' : 'once-opt') + '="' + i + '" aria-pressed="' + on + '">' + flag +
      '<span class="ak5-qty__n">' + o.qty + ' ' + unitWord(o.qty) + '</span>' +
      '<span class="ak5-qty__f"><span class="ak5-qty__fl">' + sub + '</span><span class="ak5-qty__fs">' + subS + '</span></span>' +
      '<span class="ak5-qty__p">' + money(p.unit) + '</span><span class="ak5-qty__u">per ' + cfg.unitOne + '</span>' +
      '<span class="ak5-qty__off' + (p.off ? '' : ' is-none') + '">' + (p.off ? 'Save ' + p.off + '%' : 'Full price') + '</span>' + gift + '</button>';
  }
  function ordered(list) { return list.map(function (o, i) { return { o: o, i: i }; }).sort(function (a, b) { return a.o.qty - b.o.qty; }); }
  function renderOptions() {
    if (subWrap) {
      subWrap.innerHTML = ordered(cfg.subscribe).map(function (x) { return tile(x.o, x.i, x.i === state.sub, 'sub'); }).join('');
      subWrap.querySelectorAll('[data-ak5-plan]').forEach(function (b) { b.addEventListener('click', function () { state.sub = Number(b.getAttribute('data-ak5-plan')); state.mode = 'sub'; renderOptions(); update(); }); });
    }
    if (onceWrap) {
      onceWrap.innerHTML = ordered(cfg.once).map(function (x) { return tile(x.o, x.i, x.i === state.once, 'once'); }).join('');
      onceWrap.querySelectorAll('[data-ak5-once-opt]').forEach(function (b) { b.addEventListener('click', function () { state.once = Number(b.getAttribute('data-ak5-once-opt')); state.mode = 'once'; renderOptions(); update(); }); });
    }
  }
  function update() {
    var o = current(), p = priceFor(o);
    segBtns.forEach(function (b) { var on = b.getAttribute('data-ak5-mode') === state.mode; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    optCards.forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-ak5-opt') === state.mode); });
    if (cfg.subscribe.length) { var ps = priceFor(cfg.subscribe[state.sub]); box.querySelectorAll('[data-ak5-opt-price="sub"]').forEach(function (el) { el.innerHTML = '<b>' + money(ps.now) + '</b><s>' + money(ps.was) + '</s>'; }); }
    var po = priceFor(cfg.once[state.once]); box.querySelectorAll('[data-ak5-opt-price="once"]').forEach(function (el) { el.innerHTML = '<b>' + money(po.now) + '</b>' + (po.off ? '<s>' + money(po.was) + '</s>' : ''); });
    if (sumLine) {
      var perDay = p.now / (o.qty * (cfg.days || 30));
      sumLine.innerHTML = (state.mode === 'sub' ? o.qty + ' ' + unitWord(o.qty) + ' ' + freq(o.months).toLowerCase() : o.qty + ' ' + unitWord(o.qty) + ', one time') + ' · <b>' + money(p.unit) + '</b> a ' + cfg.unitOne + ' · <b>$' + (perDay / 100).toFixed(2) + '</b> a day';
    }
    var verb = state.mode === 'sub' ? 'Subscribe' : 'Add to bag';
    /* Oct 19: look the label up every time. Caching it broke after the first add to bag, because the
       button's contents were swapped for "Adding…" and back, which left the cached label detached. */
    var ctaLabel = cta && cta.querySelector('[data-ak5-cta-label]');
    if (ctaLabel) ctaLabel.innerHTML = verb + ' · ' + money(p.now) + (p.off ? ' <s>' + money(p.was) + '</s>' : '');
    if (gift && cfg.gift) {
      var need = Math.max(0, cfg.gift.min - o.qty);
      gift.querySelector('[data-ak5-gift-msg]').textContent = need ? 'Add ' + need + ' more ' + (cfg.gift.unit ? cfg.gift.unit + (need === 1 ? '' : 's') : unitWord(need)) + ' for a free ' + cfg.gift.name : 'Free ' + cfg.gift.name + ' unlocked';
      gift.querySelector('[data-ak5-gift-count]').textContent = Math.min(o.qty, cfg.gift.min) + ' of ' + cfg.gift.min + ' ' + cfg.unitMany;
      gift.querySelector('[data-ak5-gift-bar]').style.width = Math.min(100, Math.round(o.qty / cfg.gift.min * 100)) + '%';
    }
    if (satcLine) satcLine.textContent = (state.mode === 'sub' ? o.label + ' · ' : 'One time · ') + o.qty + ' ' + unitWord(o.qty) + ' · ' + money(p.now);
    if (satcBtn) satcBtn.textContent = (state.mode === 'sub' ? 'Subscribe · ' : 'Add to bag · ') + money(p.now);
    document.dispatchEvent(new CustomEvent('ak5:buybox', { detail: { mode: state.mode, qty: o.qty, plan: o.plan || null, price: p.now } }));
  }
  segBtns.forEach(function (b) { b.addEventListener('click', function () { state.mode = b.getAttribute('data-ak5-mode'); update(); }); });

  function lines(withPartner) {
    var o = current();
    var items = [{ id: cfg.variant, quantity: o.qty, selling_plan: state.mode === 'sub' ? o.plan : null }];
    if (withPartner && cfg.partner) {
      if (state.mode === 'sub' && cfg.bundle) return [{ id: cfg.bundle.variant, quantity: o.qty, selling_plan: o.plan }];
      items.push({ id: cfg.partner.variant, quantity: o.qty, selling_plan: state.mode === 'sub' ? o.plan : null });
    }
    return items;
  }
  /* Busy state. Buttons with a label span only swap the label text (update() writes it back);
     plain buttons keep their text in data-prev. Bubble sparks are never copied. */
  function busy(b, on, txt) {
    if (!b) return;
    b.disabled = on;
    var lbl = b.querySelector('[data-ak5-cta-label]');
    if (lbl) { if (on && txt) lbl.textContent = txt; return; }
    if (on) { b.setAttribute('data-prev', b.textContent.trim()); if (txt) b.textContent = txt; }
    else if (b.getAttribute('data-prev')) { b.textContent = b.getAttribute('data-prev'); }
  }
  function add(withPartner, btn) {
    if (!window.AK5 || !AK5.addToCart) return;
    busy(btn, true, 'Adding…');
    AK5.addToCart(lines(withPartner)).then(function () {
      if (added) { added.hidden = false; added.textContent = withPartner ? 'Both added. Stay wavey.' : 'Added to your bag. Stay wavey.'; setTimeout(function () { added.hidden = true; }, 4000); }
    }).catch(function (e) { alert(e.message); }).then(function () { busy(btn, false); update(); });
  }
  if (cta) cta.addEventListener('click', function () { add(false, cta); });
  if (satcBtn) satcBtn.addEventListener('click', function () { add(false, satcBtn); });
  box.querySelectorAll('[data-ak5-add-both]').forEach(function (b) { b.addEventListener('click', function () { add(true, b); }); });
  document.querySelectorAll('[data-ak5-add-both-outside]').forEach(function (b) { b.addEventListener('click', function () { add(true, b); }); });
  /* "Start my 90 days" style links elsewhere on the page select the 3-month plan and scroll up */
  document.querySelectorAll('[data-ak5-pick-plan]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault(); state.mode = 'sub';
      var q = Number(b.getAttribute('data-ak5-pick-plan')) || 3;
      cfg.subscribe.forEach(function (o, i) { if (o.qty === q) state.sub = i; });
      renderOptions(); update(); box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* sticky bar visibility */
  if (satc && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) { satc.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }, { threshold: 0 });
    io.observe(cta || box);
  }
  renderOptions(); update();
})();
